import './Game.scss';
import MonsterArea from './MonsterArea';
import PlayerArea from './PlayerArea';
import StatusBar from './StatusBar';
import BackgroundImageAsset from "../Components/BackgroundImageAsset";
import PopUp from '../Components/Popup'
import { useAppSelector } from '../redux';
import { RootState } from '../store';
import { LOCATION_CLASSES } from '../Enums/Attributes'
import BottomBar from './BottomBar';

function BattleScreen() {

  const gameState = useAppSelector((state: RootState) => state.game)
  const content = `A wild ${gameState.monster.name || ''} appears!`;
  const mapName = LOCATION_CLASSES.find(l => l.name === gameState.levelName).sprite
  return (
    <>

      <StatusBar />

      <div className="battle-screen">


        <BackgroundImageAsset name={mapName} />
        {gameState.monster.isVisible && <MonsterArea />}
        <PlayerArea />
        <PopUp />
      </div>
      <BottomBar />

    </>

  );
}

export default BattleScreen;
